export const lightTheme = {
  bg: "#f5f7fb",
  card: "#ffffff",
  text: "#111827",
  mutedText: "#6b7280",
  border: "#e5e7eb",
  sidebar: "#ffffff",
  navbar: "rgba(255,255,255,0.75)",
  primary: "#6366f1",
  shadow: "0 8px 30px rgba(0,0,0,0.06)",
  track: "#e5e7eb",
  success: "#22c55e",
  danger: "#ef4444",
  warning: "#f59e0b",
  overlay: "rgba(0,0,0,0.45)",
  glass: "rgba(255,255,255,0.7)",
  logoText: `
    linear-gradient(
      90deg,
      #0f172a 0%,
      #334155 50%,
      #64748b 100%
    )
  `,

  logoAccent: `
    linear-gradient(
      135deg,
      #7c3aed 0%,
      #4f46e5 30%,
      #0891b2 70%,
      #06b6d4 100%
    )
  `,

  logoShadow:
    "0 2px 12px rgba(15,23,42,0.08)",

};

export const darkTheme = {
  bg: "#0f172a",
  card: "#111827",
  text: "#f9fafb",
  mutedText: "#9ca3af",
  border: "#1f2937",
  sidebar: "rgba(17,24,39,0.88)",
  navbar: "rgba(17,24,39,0.78)",
  primary: "#818cf8",
  shadow: "0 10px 35px rgba(0,0,0,0.45)",
  track: "#1e293b",
  success: "#22c55e",
  danger: "#ef4444",
  warning: "#f59e0b",
  overlay: "rgba(0,0,0,0.65)",
  glass: "rgba(17,24,39,0.72)",
  logoText: `
    linear-gradient(
      90deg,
      #ffffff 0%,
      #dbe4ff 45%,
      #94a3b8 100%
    )
  `,

  logoAccent: `
    linear-gradient(
      135deg,
      #8b5cf6 0%,
      #6366f1 30%,
      #06b6d4 70%,
      #67e8f9 100%
    )
  `,

  logoShadow:
    "0 2px 18px rgba(255,255,255,0.08)",
};